<template>
  <span>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Note Details
        </v-card-title>

        <v-card-text v-if="note" class="pt-4">
          <div class="note-full-content mb-4" style="white-space: pre-wrap">
            {{ note.content }}
          </div>
          <div class="grey--text text--darken-1 caption">
            {{ formatDate(note.created_at) }} - added by
            {{ note.admin_name }}
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="error" text @click="confirmDelete"> Delete </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteConfirm" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline"> Delete Note </v-card-title>
        <v-card-text>
          Are you sure you want to delete this note? This action cannot be
          undone.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="showDeleteConfirm = false">
            Cancel
          </v-btn>
          <v-btn color="error" text @click="handleDelete"> Delete </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'ViewNoteDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    note: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showDeleteConfirm: false,
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return ''
      return dayjs(date).format('DD - MM - YYYY, h:mm a')
    },

    close() {
      this.dialog = false
    },

    confirmDelete() {
      this.showDeleteConfirm = true
    },

    handleDelete() {
      this.showDeleteConfirm = false
      this.$emit('deleted', this.note)
    },
  },
}
</script>
